export default __webpack_public_path__ + "eb8fc09.png";